module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/core-js/library/modules/_html.js
// module id = 24
// module chunks = 0